import React, { FC, useState } from 'react'
import * as LocalStyles from './styles'
import * as Styles from '../styles'
import { ModalButton } from '../styles'
import ModalTemplate from 'uiKit/ModalTemplate'
import styles from './styles.module.scss'
import { useKeyOnChange, useModalToggle } from '../hooks'
import { TrainButtonState } from '../util/button'
import { SparklesIcon } from '../../../../../uiKit/icons/SparklesIcon'
import { unknownQuestionService } from '../../../api/unknownQuestions'
import { saveAs } from 'file-saver'
import LoaderSmall from 'uiKit/loaders/loaderSmall'
import { useUnknownQuestions } from '../context'

export type ExportQuestionsModalProps = {
  toggleModal: () => void
  isOpen: boolean
}

const Component: FC<ExportQuestionsModalProps> = ({ toggleModal, isOpen }) => {
  const [isLoading, setIsLoading] = useState(false)
  const { getSearchRequestParams } = useUnknownQuestions()

  const handleExport = async () => {
    setIsLoading(true)

    try {
      const currentDate = new Date()

      const formattedDate =
        `${String(currentDate.getDate()).padStart(2, '0')}-` +
        `${String(currentDate.getMonth() + 1).padStart(2, '0')}-` +
        `${currentDate.getFullYear()}_` +
        `${String(currentDate.getHours()).padStart(2, '0')}-` +
        `${String(currentDate.getMinutes()).padStart(2, '0')}`

      const exportFilteredParams = getSearchRequestParams()
      delete exportFilteredParams.limit
      delete exportFilteredParams.page
      const blob = await unknownQuestionService.exportQuestions(exportFilteredParams)
      const fileName = `questions-${formattedDate}.xlsx`

      saveAs(blob, fileName)
      toggleModal()
    } catch (error) {
      console.error('Error exporting questions:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <LocalStyles.ExportIconButton onClick={toggleModal}>
        <LocalStyles.ExportIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 24">
          <path d="M9.14953 15.7077C9.65051 15.7077 10.0631 15.2912 10.0631 14.8053V4.82003L9.98449 3.34257L10.5935 4.06643L11.9786 5.5538C12.1357 5.73229 12.3617 5.82153 12.5876 5.82153C13.0296 5.82153 13.3931 5.49431 13.3931 5.02826C13.3931 4.79028 13.3047 4.6118 13.1377 4.44323L9.83714 1.2404C9.61121 1.00242 9.39511 0.923096 9.14953 0.923096C8.91378 0.923096 8.69767 1.00242 8.47174 1.2404L5.17119 4.44323C5.00419 4.6118 4.90596 4.79028 4.90596 5.02826C4.90596 5.49431 5.26942 5.82153 5.71145 5.82153C5.93739 5.82153 6.17314 5.73229 6.33031 5.5538L7.70554 4.06643L8.32439 3.34257L8.24581 4.82003V14.8053C8.24581 15.2912 8.65838 15.7077 9.14953 15.7077ZM3.50126 23.6106H14.8076C16.9294 23.6106 18.0296 22.5099 18.0296 20.3979V10.6307C18.0296 8.51865 16.9294 7.41799 14.8076 7.41799H12.1456V9.3615H14.6897C15.5935 9.3615 16.1043 9.83746 16.1043 10.7993V20.2293C16.1043 21.1911 15.5935 21.6671 14.6897 21.6671H3.61914C2.7056 21.6671 2.20462 21.1911 2.20462 20.2293V10.7993C2.20462 9.83746 2.7056 9.3615 3.61914 9.3615H6.18296V7.41799H3.50126C1.37948 7.41799 0.279297 8.51865 0.279297 10.6307V20.3979C0.279297 22.5099 1.37948 23.6106 3.50126 23.6106Z" />
        </LocalStyles.ExportIcon>
      </LocalStyles.ExportIconButton>
      <ModalTemplate
        containerClasses={styles.modal}
        open={isOpen}
        title="Download questions"
        titleIcon={
          <Styles.TitleIconWrapper>
            <SparklesIcon />
          </Styles.TitleIconWrapper>
        }
        onClose={toggleModal}
        withFooter={false}>
        <Styles.ModalContainer>
          {isLoading ? (
            <LoaderSmall showLoader={true} />
          ) : (
            <>
              <Styles.SubHeader>Click the button to download in XLSX format.</Styles.SubHeader>
              <Styles.ModalButtonContainer>
                <ModalButton onClick={() => handleExport()} state={TrainButtonState.ACTIVE}>
                  Download
                </ModalButton>
              </Styles.ModalButtonContainer>
            </>
          )}
        </Styles.ModalContainer>
      </ModalTemplate>
    </>
  )
}

export const ExportQuestionsModal = () => {
  const { isOpen, toggleModal } = useModalToggle()

  const key = useKeyOnChange(isOpen)

  return <Component {...{ isOpen, toggleModal, key }} />
}
